<template>
  <div :id="prefix" class="position-relative section" :class="annotationClass">

    <fade-transition>
      <div class="orange-gradient" v-if="canSwitch && atHome">
      </div>
    </fade-transition>

    <div class="aspectContainer">
    </div>

    <slot name="intro" v-if="atHome || (!zoomActuallyPlaying && !currentAnnotation)"></slot>

    <transitions
      :current-annotation="currentAnnotation"
      :current-transition="currentTransition"
      :prefix="prefix"
      :states="states"
      @go-home="goHome"
      @transition-ended="transitionEnded"
    >
    </transitions>

    <div class="benefits-gradient" v-if="canSwitch && !atHome">
    </div>

    <fade-transition>
      <div class="orange-gradient overlay" v-if="!canSwitch && zoomActuallyPlaying">
      </div>
    </fade-transition>

    <div id="annotationContainer" v-show="!zoomActuallyPlaying && currentAnnotation">
      <slot name="annotations"></slot>
    </div>

    <slot name="videos"></slot>

    <hotspots
      :states="states"
      v-if="atHome && canSwitch"
      @navigate-to="navigateTo"
    >
    </hotspots>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { FadeTransition } from 'vue2-transitions'

import section from '@/assets/js/section'
import util from '@/assets/js/util'

import Hotspots from '@/components/Hotspots'
import Transitions from '@/components/Transitions'

export default {
  components: { FadeTransition, Hotspots, Transitions },
  computed: {
    annotationClass () {
      const out = []
      if (this.currentState) {
        out.push(this.currentState.id)
        out.push('zoomed')
      } else if (!this.canSwitch) {
        out.push('zoomed')
      }
      return out
    },
    atHome () {
      console.log('atHome: ' + (this.currentIndex === -1))
      return this.currentIndex === -1
    },
    ...mapGetters([
      'shouldClose',
      'zoomActuallyPlaying'
    ])
  },
  data () {
    return {
      canSwitch: true,
      currentAnnotation: null,
      currentAnnotationIndex: 0,
      currentAnnotationVideo: null,
      currentIndex: -1,
      currentState: null,
      currentTransition: null,
      multiStep: false,
      nextTransition: null
    }
  },
  methods: {
    findVideo (mp4) {
      return util.staticPrefix() + 'mp4/' + this.prefix + '/' + mp4
    },
    goHome () {
      this.multiStep = false
      this.$emit('go-home')
    },
    navigateTo (index) {
      this.$emit('navigate-to', index)
    },
    resetScene () {
      section.goHome(this)
    },
    switchAnnotation (index) {
      section.navigateTo(this, index)
    },
    transitionEnded () {
      this.$emit('transition-ended')
      section.transitionEnded(this)
    }
  },
  /*
  mounted () {
    util.cssBackground(this.prefix, this.prefix + '/still.png')
  },
  */
  name: 'Section',
  props: {
    next: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ''
    },
    prev: {
      type: Number,
      default: 0
    },
    reset: {
      type: Boolean,
      default: false
    },
    states: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    currentAnnotation: function (val) {
      this.$emit('switch-annotation', val)
    },
    next: function (val) {
      this.navigateTo(this.currentIndex + 1)
    },
    prev: function (val) {
      this.navigateTo(this.currentIndex - 1)
    },
    reset: function (val) {
      if (val) {
        this.resetScene()
      }
    },
    shouldClose () {
      this.$store.commit('shouldClose', false)
      this.goHome()
    }
  }
}
</script>
